import _merge from 'lodash/merge'

// This is default config
// It merges with questions.contacts.config.fields (form's config)

export default ({ config }) => _merge({
  name: {
    dataKey: 'name',
    inputType: 'text',
    label: 'Name',
    placeholder: 'Enter name',
  },
  description: {
    dataKey: 'description',
    inputType: 'text',
    label: 'Description',
    placeholder: 'Enter description',
  },
  employers: {
    dataKey: 'employers',
    inputType: 'text',
    label: 'Employers',
    placeholder: 'Enter employers',
  },
  showInCatalog: {
    dataKey: 'showInCatalog',
    inputType: 'yesNo',
    label: 'Show In Catalog',
  },
}, config.fields)
